"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Bid = void 0;
class Bid {
    type = "CpaBid";
    bid;
}
exports.Bid = Bid;
//# sourceMappingURL=Bid.js.map